import {sendRequest} from "../axios";

export default {
  state: {
    likes: {},
  },
  mutations: {
  },
  actions:{

  },
  getters: {
  },
};
